import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveComWixpressPingHubApiPublicNotificationsServiceUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'api._api_base_domain_': [
      {
        srcPath: '/notifications-hub-server',
        destPath: '',
      },
    ],
    'www._base_domain_': [
      {
        srcPath: '/_api/ping/hub',
        destPath: '',
      },
      {
        srcPath: '/_api/ping/notifications',
        destPath: '',
      },
    ],
    'manage._base_domain_': [
      {
        srcPath: '/_api/ping/hub',
        destPath: '',
      },
      {
        srcPath: '/_api/ping/notifications',
        destPath: '',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/notifications/v3/notify',
        destPath: '/v3/notify',
      },
      {
        srcPath: '/notifications/v2/notify',
        destPath: '/v2/notifications/notify',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/ping/notifications/v3/notify',
        destPath: '/v3/notify',
      },
    ],
    _: [
      {
        srcPath: '/ping/notifications/v3/notify',
        destPath: '/v3/notify',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_notifications_notifications';

/**
 * Sends a notification.
 *
 *
 * The `notify()` function sends a [notification](https://support.wix.com/en/article/about-your-dashboard-notifications) to the specified recipients on the specified channels.
 *
 * List the the channels for the notification in the `channels` parameter .
 *
 * List the recipients for the notification in the `toContacts`, `toSiteContributors`, and `toTopicsSubscribers` parameters.
 */
export function notify(payload: object): RequestOptionsFactory<any> {
  function __notify({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.ping.notifications.v1.public_notification',
      method: 'POST' as any,
      methodFqn: 'com.wixpress.ping.hub.api.PublicNotificationsService.Notify',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressPingHubApiPublicNotificationsServiceUrl({
        protoPath: '/api/v1/notify',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __notify;
}
